import React from "react";
import { Helmet } from "react-helmet";

import TopBar from "../../../components/TopBar";
import BottomBar from "../../../components/BottomBar";
import ProductHero from "../../../components/Products/NAMUniversalII/ProductHero";
import ProductSections from "../../../components/Products/NAMUniversalII/ProductSections";
import interfaceImage from "../../../static/images/nam_universal_ii/nam-universal-ii-interface.webp";
import "../../../components/Products/NAMUniversalII/namUniversalII.scss";

const NAMUniversalIIPage = () => (
  <div className="nam-universal-ii">
    <Helmet>
      <title>WaveMind Audio | NAM Universal II</title>
      <meta
        name="description"
        content="NAM Universal II is a complete guitar and bass signal chain built around Neural Amp Modeler capture playback."
      />
      <meta name="robots" content="noindex,nofollow,noarchive" />
      <link rel="preload" as="image" href={interfaceImage} />
    </Helmet>
    <TopBar menuValue="1" />
    <main>
      <ProductHero />
      <ProductSections />
    </main>
    <BottomBar />
  </div>
);

export default NAMUniversalIIPage;
